import * as  React from 'react';
import { Container, Spinner } from 'react-bootstrap';
import { useRouteMatch } from 'react-router'
import axios from 'axios'
import { unauthorizedRequest } from '../../utils/RequestMethods';

import config from '../../constants/config';
import { copyObject } from '../../utils';
import { Addresses } from './Addresses';
import { CalendarPicker } from './CalendarPicker';
import FormQuote from './FormQuote';
import MoveType from './MoveType';

const stringLitArray = <L extends string>(arr: L[]) => arr;
const MoveTypeT = stringLitArray(["apartment", "house"]);
export type MoveTypeTStrings = (typeof MoveTypeT)[number];

interface FieldsFormQuoteT {
    addressFrom: string
    addressTo: string
    moveType: MoveTypeTStrings | null
    homeSize: string
    moveDate: string
    firstName: string
    lastName: string
    email: string
    phone: string
    noAddressTo: boolean
}

const initFieldsFormQuote: FieldsFormQuoteT = {
    addressFrom: "",
    addressTo: "",
    moveType: null,
    homeSize: null,
    moveDate: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    noAddressTo: false,
}

const initSections = {
    Addresses: true,
    CalendarPicker: false,
    MoveType: false,
    FormQuote: false,

}
export interface IQuoteScreenProps {

}

const QuoteScreen: React.FC<IQuoteScreenProps> = ({ }) => {
    const [token, setToken] = React.useState(null)
    const [sections, setSections] = React.useState(initSections);
    const [fields, setFields] = React.useState(initFieldsFormQuote);
    const [validateSuccess, setValidateSuccess] = React.useState(null)
    const [company, setCompany] = React.useState({ name: "Movesheet" })
    const match = useRouteMatch()
    const containerRef = React.useRef(null)
    React.useEffect(() => {

        if (match && match.params && match.params.token) {
            const regex = /([a-zA-Z0-9\-._~\+\/=]+)/;
            if (match.params.token != "" && match.params.token != null) {
                setToken(match.params.token)
                validateToken(match.params.token);
            }

        }
    }, [])



    const scrollTop = () => {
        if (containerRef) {
            containerRef.current.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
        }
    }


    const validateToken = async (token) => {
        let params = {
            token: token,
        }
        // check token from back-end server-node
        axios.post(`/validateToken`, params).then((res) => {
            if (res && res.status == 200 && res.data && res.data.client) {
                setValidateSuccess(true)
                setCompany(res.data.client)
            } else {
                console.log('nononono')
                setValidateSuccess(false)

            }

        }).catch((error) => {
            console.log('nopenope')
            setValidateSuccess(false)
        })
    }
    /**
     * onChangeInputs
     * @param key 
     * @param value 
     */
    const onChangeInputs = (key: string, value: any) => {
        const cloneFields = copyObject(fields)
        cloneFields[key] = value

        if (key == "moveType" && fields.moveType != null) {
            cloneFields["homeSize"] = value == "apartment" ? "ST" : "H1"
        }

        setFields(cloneFields)
        refreshUi(cloneFields)
    }

    /**
     * refreshUi
     * @param nfields 
     */
    const refreshUi = (nfields: FieldsFormQuoteT) => {
        let cloneSections = copyObject(initSections)
        if (!nfields.noAddressTo && nfields.addressFrom != "" && nfields.addressTo != "") {
            cloneSections.CalendarPicker = true;
        } else if (nfields.noAddressTo == true && nfields.addressFrom != "") {
            cloneSections.CalendarPicker = true;
        }

        if (cloneSections.CalendarPicker == true && nfields.moveDate != null && nfields.moveDate != "") {
            cloneSections.MoveType = true;
        }

        if (cloneSections.MoveType == true && nfields.moveType != null && nfields.homeSize != null) {
            cloneSections.FormQuote = true;
        }
        setTimeout(() => {
            scrollTop();
            asyncHeightPage()
        }, 1);

        setSections(cloneSections)
    }

    const sendHeight = (height) => {
        if (window) {
            window.parent.postMessage(height, "*");
        }
    }

    const asyncHeightPage = () => {
        if (containerRef && containerRef.current) {

            sendHeight(containerRef.current.offsetHeight);
        }
    }

    /**
     * 
     */
    const submit = async (): Promise<void | any> => {
        return await unauthorizedRequest(`${config.url.wpJson}/wp/v2/movesheet/jobs`, fields, "POST", token)
    }

    // render loading
    if (validateSuccess == null) {
        return (
            <Container className="mt-5 text-center">
                <Spinner animation="border" variant="info" />
            </Container>
        )
    }
    if (validateSuccess == false) {
        return (
            <Container className="mt-5 text-center">
                <span className="text-danger text-center">Error! Could not load MoveSheet Plugin.</span>
            </Container>

        )
    }
    return (
        <Container className="mt-2 mb-5 p-2"

            ref={containerRef}
        //   style={{ overflowX: "hidden", overflowY: "hidden" }}
        >
            {sections.Addresses && <Addresses addressFrom={fields.addressFrom} addressTo={fields.addressTo} noAddressTo={fields.noAddressTo} onChangeInputs={onChangeInputs} />}
            {sections.CalendarPicker && <CalendarPicker moveDate={fields.moveDate} onChangeInputs={onChangeInputs} />}
            {sections.MoveType && <MoveType moveType={fields.moveType} homeSize={fields.homeSize} onChangeInputs={onChangeInputs} />}
            {sections.FormQuote && <FormQuote
                firstName={fields.firstName}
                lastName={fields.lastName}
                email={fields.email}
                phone={fields.phone}
                company={company}
                submit={submit}
                onChangeInputs={onChangeInputs} />}
        </Container>
    );
}

export default QuoteScreen;
export { QuoteScreen };